import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 768px) {
        align-items: center;
        flex-direction: column-reverse;
        text-align: center;
    }
`;

export const StyledLink = styled(Link)`
    font-size: 12px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.gray};
    display: inline;
    font-weight: bold;
    text-transform: uppercase;
    margin-left: ${({ theme }) => theme.spacing * 10}px;
    text-decoration: none;
    cursor: pointer;
    @media (max-width: 768px) {
        display: block;
        margin: 0 0 ${({ theme }) => theme.spacing * 8}px;
    }
`;

export const LinkOutside = styled.p`
    margin: 0;
    font-size: 12px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.gray};
    display: inline;
    font-weight: bold;
    text-transform: uppercase;
    margin-left: ${({ theme }) => theme.spacing * 10}px;
    text-decoration: none;
    cursor: pointer;
    @media (max-width: 768px) {
        display: block;
        margin: 0 0 ${({ theme }) => theme.spacing * 8}px;
    }
`;

export const Image = styled.img`
    width: 138px;
`;
